import { createSelector } from 'reselect';

import getOrderLeadTimes from './getOrderLeadTimes';
import { DELIVERY_SALE_TYPES } from '../constants/saleType';

/**
 * # getDeliveryOrderLeadTimes
 * This gets delivery order lead times sorted by time
 */
export default createSelector([getOrderLeadTimes], orderLeadTimes =>
  orderLeadTimes
    .filter(value => DELIVERY_SALE_TYPES.includes(value.SaleType))
    .sort((a, b) => a.Time - b.Time),
);
